import { useAdminAuth } from "./AdminAuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

const PermissionRoute = ({ permission, children }) => {
    const { hasPermission, isLoading } = useAdminAuth();

    if (isLoading) return null;

    if (!hasPermission(permission)) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center p-5">
                <FontAwesomeIcon icon={faLock} size="2x" className="text-secondary mb-3" />
                <h5 className="petit_titre">Accès refusé</h5>
                <p className="texte_brut text-muted text-center">
                    Vous n'avez pas la permission d'accéder à cette section.
                    <br />
                    Contactez l'administrateur principal si vous pensez que c'est une erreur.
                </p>
            </div>
        );
    }

    return children;
};

export default PermissionRoute;